import { render, staticRenderFns } from "./PremiumTableItems.vue?vue&type=template&id=4e9d83d5&scoped=true&"
import script from "./PremiumTableItems.vue?vue&type=script&lang=js&"
export * from "./PremiumTableItems.vue?vue&type=script&lang=js&"
import style0 from "./PremiumTableItems.vue?vue&type=style&index=0&id=4e9d83d5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9d83d5",
  null
  
)

export default component.exports